import PropTypes from "prop-types";

// See `filterDropdown` from `Column` in `Table` API
// -> https://4x.ant.design/components/table/#Column
export const FilterDropdownAttributes = {
  visible: PropTypes.bool,
  selectedKeys: PropTypes.array,
  setSelectedKeys: PropTypes.func,
  confirm: PropTypes.func,
};

export const FilterDropdownShape = PropTypes.shape(FilterDropdownAttributes);
